import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { Link } from 'react-router-dom';
import { RouteSection } from '../../../types';
import { ProductPageQuery } from '../../../../../types';
import { getScrollLinkOffset } from '../../../utils';

const LinkToReviews: React.FC<ILinkToReviewsProps> = props => {
  const { product, routeSection, children, onClick } = props;
  const { linkTo, t } = useContext(AppContext);
  return routeSection === 'reviews' ? (
    <ScrollLink
      to="Reviews"
      calculateOffset={getScrollLinkOffset}
      onClick={onClick}
    >
      {children}
    </ScrollLink>
  ) : (
    <Link
      to={linkTo('productReviews', product)}
      onClick={onClick}
      aria-label={t('product', 'tabs.reviews')}
    >
      {children}
    </Link>
  );
};

interface ILinkToReviewsProps {
  product: ProductPageQuery['product'];
  routeSection?: RouteSection;
  onClick?: (ev: React.MouseEvent) => void;
  children?: React.ReactNode;
}

export default memo(LinkToReviews);
